import React from 'react';
import { Link } from 'react-router-dom';
import { APP_URL } from '../env';

const Footer: React.FC = () => {
  return (
    <footer style={{
      background: 'rgba(15,23,42,0.8)',
      borderTop: '1px solid rgba(148,163,184,0.15)',
      padding: '48px 0 32px',
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 40,
          marginBottom: 48,
        }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <img src="/logo192.png" alt="PRETTIFAI" style={{ width: 28, height: 28, borderRadius: 5 }} />
              <span style={{ fontSize: '1rem', fontWeight: 800, letterSpacing: '0.08em' }}>PRETTIFAI</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.7 }}>
              AI-powered finance document management.<br />
              Stop chasing documents. Let PRETTIFAI do it.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 style={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#94a3b8', marginBottom: 16 }}>Product</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a href="/#features" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Features</a>
              <Link to="/pricing" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Pricing</Link>
              <a href={APP_URL} style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Sign In</a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 style={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#94a3b8', marginBottom: 16 }}>Legal</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/terms" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Terms of Service</Link>
              <Link to="/privacy" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Privacy Policy</Link>
              <Link to="/refund" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Refund Policy</Link>
              <a href="/docs/prettifai-soc2-type-i-report.pdf" target="_blank" rel="noopener noreferrer"
                style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>SOC 2 Type I Report</a>
              <a href="/docs/prettifai-lov-34.pdf" target="_blank" rel="noopener noreferrer"
                style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>LOV Letter</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#94a3b8', marginBottom: 16 }}>Contact</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/contact" style={{ color: '#cbd5e1', fontSize: '0.9rem', transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
                onMouseLeave={e => (e.currentTarget.style.color = '#cbd5e1')}>Contact / Support</Link>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div style={{
          borderTop: '1px solid rgba(148,163,184,0.15)',
          paddingTop: 24,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 16,
        }}>
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>
            © {new Date().getFullYear()} PRETTIFAI. All rights reserved.
          </p>
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>
            Made with ☕ &amp; AI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
